// extracted by mini-css-extract-plugin
export var container = "_dn-1";
export var cornerButtonContainer = "_dn-6";
export var disabled = "_dn-2";
export var dragActive = "_dn-3";
export var fileContainer = "_dn-5";
export var hiddenInput = "_dn-4";
export var widthContainer = "_dn-0";